import React from 'react';
import {
  routeBoundaryCurve,
  routePathWithEndpointOverlap,
} from '../../utils/mindmap/edgeRouting';
import { getThemeEdgeStyle } from '../../config/themes';
import '../../styles/components/Line.css';

/**
 * Boundary-anchored connection that follows the nodes' current geometry.
 */
const Line = ({
  fromRect,
  toRect,
  resolvedRoute = null,
  side = null,
  opacity = 1,
  theme = null,
  isDarkMode = false,
  isSelected = false,
  isMuted = false,
  fromId = null,
  toId = null,
  isLayoutAnimating = false,
}) => {
  // Don't render if coordinates are missing
  if ((!fromRect || !toRect) && !resolvedRoute) return null;

  const route = resolvedRoute || routeBoundaryCurve(fromRect, toRect, { side });
  const visiblePath = routePathWithEndpointOverlap(route);
  const themeEdge = getThemeEdgeStyle(theme, { isDarkMode, isSelected });
  const stroke = themeEdge?.stroke || (isSelected
    ? (isDarkMode ? '#7dd3fc' : '#2563eb')
    : (isDarkMode ? '#64748b' : '#94a3b8'));
  const strokeWidth = themeEdge?.strokeWidth || (isSelected ? 2.75 : 1.75);
  const state = isSelected ? 'selected' : isMuted ? 'muted' : 'default';

  return (
    <path
      className={`mind-map-edge mind-map-edge--${state}${isLayoutAnimating ? ' mind-map-edge--layout-transition' : ''}`}
      d={visiblePath}
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      opacity={opacity}
      data-edge-state={state}
      data-edge-side={route.side || 'automatic'}
      data-edge-target-side={route.targetSide || undefined}
      data-edge-routing={route.kind || 'smooth'}
      data-edge-routing-fallback={route.routingFallback || undefined}
      data-edge-from={fromId || undefined}
      data-edge-to={toId || undefined}
      data-edge-position-animating={isLayoutAnimating ? 'true' : 'false'}
      aria-hidden="true"
    />
  );
};

export default Line;
